module.exports = __webpack_public_path__ + "static/img/591.b405162.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/rjzz/591.jpg
// module id = 7dQo
// module chunks = 0